<template>
    <div class="people">
        <slot>
            <div
                class="num fs14 Disp_AC"
                :style="disabled ? {zIndex: 3, cursor: 'no-drop' } : {}"
                v-if="isMultiple"
                :class="{ has_people: id.length }"
            >{{ id.length ? `${id.length}` : $t('common.请选择') }}</div>
        </slot>
        <el-select
            :multiple="isMultiple"
            :multiple-limit="limit"
            class="People_Select"
            :style="{ opacity: onlyPop ? 0 : 1 }"
            :clearable="!onlyPop"
            collapse-tags
            :size="size"
            :no-data-text="noDataText || $t('common.暂无数据')"
            :popper-class="`People_Select_Popper ${onlyPop ? 'Only_Pop' : ''}`"
            v-model="id"
            :disabled="disabled"
            :placeholder="isMultiple ? '' : placeholder ? placeholder : $t('common.请选择')"
            @change="handleChange"
            @visible-change="$emit('visible-change', $event)"
        >
            <el-option
                v-if="isMultiple && (showLocalSearch || copyPeopleList.length) && limit === 0"
                class="all Disp_AC no_checkbox"
                :class="{ selected: selectAll }"
                value="all"
            >
                <template v-if="showLocalSearch">
                    <el-input
                        style="width: 280px;"
                        class="No_Border No_BgColor"
                        :placeholder="$t('club.搜索')"
                        v-model="localSearchName"
                        v-debounce="[searchLocalList, 'keydown', 300]"
                        @click.native.stop
                    >
                        <i slot="prefix" class="el-input__icon el-icon-search" />
                    </el-input>
                </template>
                <template v-else>
                    <div class="select_all" @click="handleAll">
                        {{ $t('common.全选') }}
                        <el-checkbox v-model="isAll" @change="checkboxAllFun" @click.native.stop></el-checkbox>
                    </div>
                </template>
            </el-option>
            <el-option
                class="Disp_AC"
                v-for="(item, index) in copyPeopleList"
                :key="item.id + index"
                :disabled="currentDisabled(item)"
                :label="(item.number || '') + ' ' + (item['name' + $lang] || item.name)"
                :value="item.id"
            >
                <cl-avatar v-if="showAvatar" :src="item.avatar" width="32" height="32"></cl-avatar>
                <span
                    v-if="showPlayerStatus"
                    class="Text_Over"
                    style="max-width:150px;"
                    :title="item['name' + $lang] || item.name"
                    :class="{ red: item.injury && !item.teamTraining, green: item.injury && item.teamTraining, mr70: isCamp ,ml12: !isCamp}"
                >{{ item.number }} {{ item['name' + $lang] || item.name }}</span>
                <span
                    v-else
                    class="ml12 Text_Over"
                    style="max-width:150px;"
                    :title="item['name' + $lang] || item.name"
                >{{ item.number }} {{ item['name' + $lang] || item.name }}</span>
            </el-option>
        </el-select>
    </div>
</template>

<script>
/**
 * ComponentName: people list
 * Created Date:2022/4/24
 * Author: Nancy
 * Modify: shishuo·zhang 2022/4/28
 * Modify: 张钧 2022/8/2 列表本地搜索
 * 组件说明：
 * 这组组件是选球员、教练的组件，支持单选，多选
 * eg:
 *     <cl-people-list></cl-people-list>
 */
export default {
    name: 'cl-people-list',
    model: {
        prop: 'value',
        event: 'change',
    },
    data () {
        return {
            id: JSON.parse(JSON.stringify(this.value)) || (this.isMultiple ? [] : ''),
            localSearchName: '', // 本地搜索名称
            copyPeopleList: [], // 人员列表副本
            isAll: false,
        };
    },
    watch: {
        value: {
            immediate: true,
            handler () {
                this.id = JSON.parse(JSON.stringify(this.value));
                if (this.showPlayerStatus) {
                    if (this.peopleList.length > 0) {
                        this.isAll = this.id.length >= this.peopleList.length - this.injuryNum;
                    }
                } else {
                    this.isAll = this.peopleList.length && this.id.length >= this.peopleList.length;
                }
            },
            deep: true,
        },
        // 球员列表变化后，检查全选状态
        copyPeopleList(newV, oldV = []) {
            if (newV.length === oldV.length) {
                return;
            }
            if (this.showPlayerStatus) {
                if (this.peopleList.length > 0) {
                    this.isAll = this.id.length >= this.peopleList.length - this.injuryNum;
                }
            } else {
                this.isAll = this.peopleList.length && this.id.length >= this.peopleList.length;
            }
        },
        peopleList: {
            immediate: true,
            handler () {
                this.copyPeopleList = this.peopleList;
            },
        },
    },

    props: {
        value: {
            type: [String, Array],
            default: '',
        },
        type: {
            type: String,
            default: 'single',
        },
        list: {
            type: Array,
            default: () => [],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            default: '',
        },
        onlyPop: {
            type: Boolean,
            default: false,
        },
        // 是否显示头像
        showAvatar: {
            type: Boolean,
            default: true,
        },
        // 是否显示球员在队/伤病状态
        showPlayerStatus: {
            type: Boolean,
            default: true,
        },
        // 自定义禁用选项
        customDisabled: {
            type: Array,
            default: () => [],
        },
        //  限制多选的数量 多选时用户最多可以选择的项目数，为 0 则不限制
        limit: {
            type: Number,
            default: 0,
        },
        // 无数据时显示的文字
        noDataText: {
            type: String,
            default: '',
        },
        // 显示本地搜索input
        showLocalSearch: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
        },
        // 是否为训练营弹窗选择梯队
        isCamp:{
            type: Boolean,
            default: false,
        } 
    },
    computed: {
        peopleList () {
            return JSON.parse(JSON.stringify(this.list));
        },
        isMultiple () {
            // 多选
            return this.type === 'multiple';
        },
        isSingle () {
            // 单选
            return this.type === 'single';
        },
        injuryNum () {
            let num = this.list.filter((item) => item.injury && !item.teamTraining);
            return num.length;
        },
        selectAll () {
            // console.log(this.id.length, this.peopleList.length - this.injuryNum)
            return this.id.length >= this.peopleList.length - this.injuryNum; // 选择的项是否等于总数
        },
    },
    methods: {
        checkboxAllFun () {
            let items = [];
            if (this.isAll) {
                let filterList = this.list.filter((item) => !(item.injury && !item.teamTraining));
                const arr = this.showPlayerStatus ? filterList : this.list; // 显示球员状态时，不筛选带病随队
                this.id = arr.map((item) => item.id);
                items = arr;
            } else {
                this.id = [];
                items = [];
            }
            this.$emit('change', this.id, items);
        },
        handleAll () {
            let items = [];
            if (this.selectAll) {
                // 等于总数 则清空
                this.id = [];
                items = [];
            } else {
                // 不等于总数 则全选
                let filterList = this.list.filter((item) => !(item.injury && !item.teamTraining));
                const arr = this.showPlayerStatus ? filterList : this.list; // 显示球员状态时，不筛选带病随队
                this.id = arr.map((item) => item.id);
                items = arr;
            }
            this.$emit('change', this.id, items);
        },
        handleChange () {
            if (this.id.indexOf('all') > -1) {
                // 有全选项
                let index = this.id.findIndex((item) => item === 'all');
                this.id.splice(index, 1);
            }

            let items = [];
            this.list.map((item) => {
                if (this.id.indexOf(item.id) > -1) {
                    items.push(item);
                }
            });
            // console.log(this.id, 'idididid')
            this.$emit('change', this.id, items);
        },
        // 当前禁用项
        currentDisabled (item) {
            let disable = false;
            if (this.customDisabled && this.customDisabled.length) {
                // 是否是自定义禁用
                disable = this.customDisabled.includes(item.id);
            } else {
                disable = item.injury && !item.teamTraining && this.showPlayerStatus;
            }
            return disable;
        },
        // 从本地搜索
        searchLocalList (searchName) {
            if (!searchName) {
                this.copyPeopleList = JSON.parse(JSON.stringify(this.peopleList));
            } else {
                this.copyPeopleList = this.peopleList.filter((item) => {
                    return (item['name' + this.$lang] || item.name).includes(searchName);
                });
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.red {
    color: $base-font-error;
}

.green {
    color: $base-color-success;
}

.people {
    display: inline-block;
    position: relative;

    .num {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        font-size: 14px;
        z-index: 1;
        padding: 0 12px;
        box-sizing: border-box;
        color: $base-font-minor;
        background: rgba(251, 253, 255, 0.8);
        font-family: SysFontR;
        border-radius: 6px;
    }

    .has_people {
        font-size: 16px;
        color: $base-font-major;
        font-family: AkrobatMedium;
    }

    .People_Select {
        position: relative;
        z-index: 2;
    }
}
.select_all {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 20px;
    /deep/.el-checkbox__inner {
        width: 18px;
        height: 18px;
    }
}
</style>
